export default {
  loading: false,
  onlineEnrollments: [],
  onlineEnrollment: {}
}
